import api from '@tyrio/api-factory';
import { DBTrackInfoApi } from '@tyrio/dto';
import { ToastHelper, ToastMessageType, ToastType } from '@tyrio/ui-library';
import { useMutation } from 'react-query';

export const useUpdateManyTrackingItems = (refetchTrackingInfo: () => void) => {
  const updateManyTrackItems = useMutation(
    (client: DBTrackInfoApi['updateMany']['request']) =>
      api.fetch<DBTrackInfoApi['updateMany']>('track_info_update_many', {
        ...client,
      }),
    {
      mutationKey: 'track_info_update_many',
      onSuccess: () => {
        refetchTrackingInfo();
        ToastHelper.showToast(
          'Track info',
          ToastType.SUCCESS,
          ToastMessageType.UPDATE,
          'Track info successfully updated!'
        );
      },
      onError: () => {
        ToastHelper.showToast(
          'Track info update',
          ToastType.ERROR,
          undefined,
          'There is an error during deleting track item!'
        );
      },
    }
  );

  return { updateManyTrackItems };
};
